"use client";
import { Icon } from "@commerce-frontend/ui/base/Icon/Icon";
import { Link } from "@commerce-frontend/ui/base/Link/Link";
import { useAuth } from "@labdigital/federated-token-react";
import { useTranslations } from "next-intl";
import { useStaticUrl } from "~/hooks/static-url";

export const WishlistLink = () => {
	const t = useTranslations("WishlistLink");
	const wishlistUrl = useStaticUrl("account/wishlist");
	const { isAuthenticated } = useAuth();

	if (!isAuthenticated) return null;

	return (
		<Link
			href={wishlistUrl}
			className="grid place-items-center rounded-full p-2 transition-colors hover:bg-blue-400 hover:text-white blacknovember:hover:bg-black blacknovember:hover:opacity-80 max-md:-m-2"
			title={t("wishlist")}
		>
			<Icon icon="heart-outline" className="bg-current" />
		</Link>
	);
};
